import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminMunicipalities = z.any()
export type TagsGetAdminMunicipalities = z.infer<typeof tagsGetAdminMunicipalities>

export const responseGetAdminMunicipalities = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.string().optional(), "address": z.string().optional(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "user": z.object({ "id": z.string(), "email": z.string(), "name": z.string(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean() }).optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminMunicipalities = z.infer<typeof responseGetAdminMunicipalities>

interface IGetAdminMunicipalities extends BaseMethodType {
  tags: TagsGetAdminMunicipalities,
  response: ResponseGetAdminMunicipalities
}
export const URL = '/admin/municipalities'
export const validation = {
  get: {
    tags: tagsGetAdminMunicipalities,
    response: responseGetAdminMunicipalities
  }
}
export interface AdminMunicipalities extends BaseRouteType {
  get: IGetAdminMunicipalities
}